import BaseMixin from '@/views/mixin.vue'
import compSearch from './search'
import comIndex from './update'

import { mapState } from 'vuex'
import {
    HttpGetLineList,
    HttpGetProductsLine,
    HttpDeletedLine,

} from '@/service/products/productline'
import { DropdownMenu, Dropdown, DropdownItem, Icon, Button } from 'view-design'

export default {
    mixins: [BaseMixin],
    components: {
        compSearch,
        comIndex
    },
    data () {
        return {
            isSuper: this.$store.state.userinfo.isSuper,
            fudingdan: 0,
        };
    },
    methods: {
        httpList: HttpGetLineList,
        handleOperate (data, type) {
            this.operate = {};
            switch (type) {
                case 'query':
                    this.operate = {
                        title: this.$t('global.common.query', { defaultValue: '查看' }),
                        show: true,
                        width: 1200,
                        component: "comIndex",
                        activeids: data,
                        querytype: 'query'
                    };
                    break;
                case 'edit': {
                    this.$router.push({
                        name: 'productLineUpdate',
                        params: { type: 'edit' },
                        query: { id: data },
                    });
                    break;
                }
                case 'add': {
                    this.$router.push({
                        name: 'productLineUpdate',
                        params: { type: 'add' },
                        query: { id: data },
                    });
                    break;
                }
                case 'deleted': {
                    this.showDel = true;
                    this.operate = {
                        title: this.$t('erp.product.operate_delete', { defaultValue: '删除操作' }),
                        desc: this.$t('erp.product.confirm_delete', { defaultValue: `确定删除操作？` }),
                        type,
                        id: data,
                    }
                    break;
                }
            }
        },
        async batchOpearte () {
            let request, { type, id } = this.operate, params = {}, callback = (res) => { this.$Message.success(res.message); };
            switch (type) {
                case 'deleted': request = HttpDeletedLine; params = { id: id }; break;
            }
            if (!request) return;
            request(params).then(res => {
                this.$Message.success(res.message);
                this.updateList();
            }, err => {
                this.$VMessage.error({
                    content: err.message,
                    duration: 30,
                    closable: true
                });
            }).finally(result => {
                this.showDel = false;
                this.operate = {};
            });
        },
    },

    computed: {
        columns () {
            let datalist = [{
                type: 'selection',
                width: 60,
            }, {
                title: this.$t('global.common.actions', { defaultValue: "操作" }),
                width: 120,
                render: (h, { row }) => {
                    const id = row.id;
                    return <Dropdown placement="bottom-start" trigger="click">
                        <Button size='small' type='info'>{this.$t('global.common.actions', { defaultValue: "操作" })} &nbsp;<Icon type="md-arrow-dropdown" /></Button>
                        <DropdownMenu slot="list" class="text-left">
                            <DropdownItem class='splitline' nativeOnClick={this.handleOperate.bind(this, id, 'query')}>{this.$t('global.common.query', { defaultValue: '查看' })}</DropdownItem>

                            <DropdownItem class='splitline' nativeOnClick={this.handleOperate.bind(this, id, 'edit')}>{this.$t('global.common.edit', { defaultValue: '编辑' })}</DropdownItem>

                            <DropdownItem class='splitline' nativeOnClick={this.handleOperate.bind(this, id, 'deleted')}>{this.$t('global.common.delete', { defaultValue: '删除' })}</DropdownItem>
                        </DropdownMenu>
                    </Dropdown >
                }
            },
            {
                title: '#ID',
                width: 80,
                key: 'id',
                sortable: true,
            },
            {
                title: this.$t('global.common.name', { defaultValue: '名称' }),
                key: 'name',
                sortable: true,
            },
            {
                title: this.$t('erp.product.project_sample_name', { defaultValue: '项目简称' }),
                key: 'projectUnicode',
                sortable: true,
            },
            {
                title: this.$t('fbb.accountmanage.description', { defaultValue: '描述' }),
                key: 'description',
                sortable: true,
                maxWidth: 200,
            },
            {
                title: this.$t('erp.product.project_incharge', { defaultValue: '项目负责人' }),
                key: 'manager',
                sortable: true,
            },
            {
                title: this.$t('global.common.updatedAt', { defaultValue: '更新时间' }),
                maxWidth: 180,
                key: 'updated',
                sortable: true,
            }
            ];
            return datalist;
        }
    }
};
